import * as echarts from 'echarts'
import darkMapStyle from '@/data/dark.js'
let colorArr = ['#245EE6','#033E8E']//渐变色
export default {
    "bridge":{
        "bezierLine":"#FFFFFF"
    },
    "bmap":{
        // "mapStyleV2":{
        //     "styleJson":darkMapStyle
        // }
    },
    "car":{
        "lineColor":'rgba(255, 255, 255, 0.15)',
        "dashColor":"rgba(255, 255, 255, 0.05)",
        "labelColor":"rgba(255, 255, 255, 0.55)",
    },
    "textColor":'rgba(255,255,255,0.65)',
    "bgColor":'rgba(255,255,255,0.65)',
    "color":[
        "#245EE6",
        "#FEC703",
        "#FD5E4E",
        "#26E38D",
        "#20CAFD",
        "#E067FF",
        "#F4E211",
        "#4E91FD",
        "#FF8E53",
        "#12ADC9",
        "#AA54F4",
        "#033E8E"
    ] ,
    "backgroundColor": "rgba(0, 0, 0, 0)",
    "textStyle": {},
    "title": {
        "textStyle": {
            "color": "rgba(255, 255, 255, 0.95)",
            "fontSize":'16'
        },
        "subtextStyle": {
            "color": "rgba(255, 255, 255, 0.65)"
        }
    },
    "line": {
        "itemStyle": {
            "borderWidth": 1
        },
        "lineStyle": {
            "width": 2
        },
        "symbolSize": 4,
        "symbol": "emptyCircle",
        "smooth": false
    },
    "radar": {
        "itemStyle": {
            "borderWidth": 1
        },
        "lineStyle": {
            "width": 1
        },
        "symbolSize": 4,
        "symbol": "emptyCircle",
        "smooth": false,
        "label": {
            "color": "rgba(255, 255, 255, 0.55)"
        }
    },
    "bar": {
        "itemStyle": {
            "barBorderWidth": 0,
            "barBorderColor": "#ccc",
            "color": new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: colorArr[0]
                },{
                offset: 0.8,
                color: colorArr[1]
            }], false)
        },
        "label": {
            "color": "rgba(255, 255, 255, 0.55)"
        }
    },
    "pie": {
        "itemStyle": {
            "borderWidth": 0,
            "borderColor": "#ccc"
        }
    },
    "scatter": {
        "itemStyle": {
            "borderWidth": 0,
            "borderColor": "#ccc"
        }
    },
    "tree":{
        "label": {
            "color": "rgba(255, 255, 255, 0.55)"
        },
        "lineStyle": {
            "width": 1,
            "color":"rgba(255, 255, 255, 0.20)"
        }
    },
    "boxplot": {
        "itemStyle": {
            "borderWidth": 0,
            "borderColor": "#ccc"
        }
    },
    "parallel": {
        "itemStyle": {
            "borderWidth": 0,
            "borderColor": "#ccc"
        }
    },
    "sankey": {
        "itemStyle": {
            "borderWidth": 0,
            "borderColor": "#ccc"
        }
    },
    "funnel": {
        "itemStyle": {
            "borderWidth": 0,
            "borderColor": "#ccc"
        }
    },
    "gauge": {
        "itemStyle": {
            "borderWidth": 0,
            "borderColor": "#ccc"
        }
    },
    "candlestick": {
        "itemStyle": {
            "color": "#eb5454",
            "color0": "#47b262",
            "borderColor": "#eb5454",
            "borderColor0": "#47b262",
            "borderWidth": 1
        }
    },
    "graph": {
        "itemStyle": {
            "borderWidth": 0,
            "borderColor": "#ccc"
        },
        "lineStyle": {
            "width": 1,
            "color": "#aaa"
        },
        "symbolSize": 4,
        "symbol": "emptyCircle",
        "smooth": false,
        "color": [
            "#5470c6",
            "#91cc75",
            "#fac858",
            "#ee6666",
            "#73c0de",
            "#3ba272",
            "#fc8452",
            "#9a60b4",
            "#ea7ccc"
        ],
        "label": {
            "color": "rgba(255, 255, 255, 0.55)"
        }
    },
    "map": {
        "itemStyle": {
            "normal": {
                "areaColor": "red",
                "borderColor": "#444",
                "borderWidth": 0.5
            },
            "emphasis": {
                "areaColor": "rgba(255,215,0,0.8)",
                "borderColor": "#444",
                "borderWidth": 1
            }
        },
        "label": {
            "normal": {
                "textStyle": {
                    "color": "rgba(255, 255, 255, 0.55)"
                }
            },
            "emphasis": {
                "textStyle": {
                    "color": "rgba(255, 255, 255, 0.55)"
                }
            }
        }
    },
    "geo": {
        "itemStyle": {
            "normal": {
                "areaColor": "red",
                "borderColor": "#444",
                "borderWidth": 0.5
            },
            "emphasis": {
                "areaColor": "rgba(255,215,0,0.8)",
                "borderColor": "#444",
                "borderWidth": 1
            }
        },
        "label": {
            "normal": {
                "textStyle": {
                    "color": "rgba(255, 255, 255, 0.55)"
                }
            },
            "emphasis": {
                "textStyle": {
                    "color": "rgba(255, 255, 255, 0.55)"
                }
            }
        }
    },
    "categoryAxis": {
        "axisLine": {
            "show": true,
            "lineStyle": {
                "color": "rgba(255, 255, 255, 0.55)"
            }
        },
        "axisTick": {
            "show": true,
            "lineStyle": {
                "color": "rgba(255, 255, 255, 0.25)"
            }
        },
        "axisLabel": {
            "show": true,
            "textStyle": {
                "color": "rgba(255, 255, 255, 0.55)"
            }
        },
        "splitLine": {
            "show": false,
            "lineStyle": {
                "color": [
                    "rgba(255, 255, 255, 0.15)"
                ]
            }
        },
        "splitArea": {
            "show": false,
            "areaStyle": {
                "color": [
                    "rgba(250,250,250,0.2)",
                    "rgba(210,219,238,0.2)"
                ]
            }
        }
    },
    "valueAxis": {
        "axisLine": {
            "show": false,
            "lineStyle": {
                "color": "rgba(255, 255, 255, 0.55)"
            }
        },
        "axisTick": {
            "show": false,
            "lineStyle": {
                "color": "rgba(255, 255, 255, 0.25)"
            }
        },
        "axisLabel": {
            "show": true,
            "textStyle": {
                "color": "rgba(255, 255, 255, 0.55)"
            }
        },
        "splitLine": {
            "show": true,
            "lineStyle": {
                "color": [
                    "rgba(255, 255, 255, 0.15)"
                ]
            }
        },
        "splitArea": {
            "show": false,
            "areaStyle": {
                "color": [
                    "rgba(250,250,250,0.2)",
                    "rgba(210,219,238,0.2)"
                ]
            }
        }
    },
    "categoryAxis3D": {
        "axisLine": {
            "show": true,
            "lineStyle": {
                "color": "rgba(255, 255, 255, 0.55)",
            },
        },
        "axisTick": {
            "show": true,
            "lineStyle": {
                "color": "rgba(255, 255, 255, 0.15)",
            },
        },
        "axisLabel": {
            "show": true,
            "textStyle": {
                "color": "rgba(255, 255, 255, 0.55)",
            },
        },

    },
    "valueAxis3D": {
        "axisLine": {
            "show": true,
            "lineStyle": {
                "color": "rgba(255, 255, 255, 0.55)",
            },
        },
        "axisTick": {
            "show": true,
            "lineStyle": {
                "color": "rgba(255, 255, 255, 0.15)",
            },
        },
        "axisLabel": {
            "show": true,
            "textStyle": {
                "color": "rgba(255, 255, 255, 0.55)",
            },
        },

    },
    "logAxis": {
        "axisLine": {
            "show": false,
            "lineStyle": {
                "color": "rgba(255, 255, 255, 0.55)"
            }
        },
        "axisTick": {
            "show": false,
            "lineStyle": {
                "color": "rgba(255, 255, 255, 0.25)"
            }
        },
        "axisLabel": {
            "show": false,
            "textStyle": {
                "color": "rgba(255, 255, 255, 0.55)"
            }
        },
        "splitLine": {
            "show": false,
            "lineStyle": {
                "color": [
                    "rgba(255, 255, 255, 0.15)"
                ]
            }
        },
        "splitArea": {
            "show": false,
            "areaStyle": {
                "color": [
                    "rgba(250,250,250,0.2)",
                    "rgba(210,219,238,0.2)"
                ]
            }
        }
    },
    "timeAxis": {
        "axisLine": {
            "show": true,
            "lineStyle": {
                "color": "rgba(255, 255, 255, 0.55)"
            }
        },
        "axisTick": {
            "show": true,
            "lineStyle": {
                "color": "rgba(255, 255, 255, 0.25)"
            }
        },
        "axisLabel": {
            "show": true,
            "textStyle": {
                "color": "rgba(255, 255, 255, 0.55)"
            }
        },
        "splitLine": {
            "show": false,
            "lineStyle": {
                "color": [
                    "rgba(255, 255, 255, 0.15)"
                ]
            }
        },
        "splitArea": {
            "show": false,
            "areaStyle": {
                "color": [
                    "rgba(250,250,250,0.2)",
                    "rgba(210,219,238,0.2)"
                ]
            }
        }
    },
    "toolbox": {
        "iconStyle": {
            "normal": {
                "borderColor": "#999"
            },
            "emphasis": {
                "borderColor": "#666"
            }
        },
        'saveAsImage' : {
            'backgroundColor': '#282C37'
        }
    },
    "legend": {
        "textStyle": {
            "color": "rgba(255, 255, 255, 0.55)"
        },
        "pageIconColor":"rgba(255,255,255,1)",
        "pageTextStyle":{
            "color":"#fff"
        },
    },
    "tooltip": {
        "axisPointer": {
            "lineStyle": {
                "color": "#ccc",
                "width": 1
            },
            "crossStyle": {
                "color": "#ccc",
                "width": 1
            }
        }
    },
    "timeline": {
        "lineStyle": {
            "color": "#DAE1F5",
            "width": 1
        },
        "itemStyle": {
            "normal": {
                "color": "rgba(255, 255, 255, 0.55)",
                "borderWidth": 1
            },
            "emphasis": {
                "color": "rgba(255, 255, 255, 0.55)"
            }
        },
        "controlStyle": {
            "normal": {
                "color": "rgba(255, 255, 255, 0.55)",
                "borderColor": "rgba(255, 255, 255, 0.55)",
                "borderWidth": 1
            },
            "emphasis": {
                "color": "rgba(255, 255, 255, 0.55)",
                "borderColor": "rgba(255, 255, 255, 0.55)",
                "borderWidth": 1
            }
        },
        "checkpointStyle": {
            "color": "#316bf3",
            "borderColor": "fff"
        },
        "label": {
            "normal": {
                "textStyle": {
                    "color": "rgba(255, 255, 255, 0.55)"
                }
            },
            "emphasis": {
                "textStyle": {
                    "color": "rgba(255, 255, 255, 0.55)"
                }
            }
        }
    },
    "visualMap": {
        "color": [
            "#bf444c",
            "#d88273",
            "#f6efa6"
        ],
        "textStyle":{
            "color":"rgba(255, 255, 255, 0.55)"
        }
    },
    "dataZoom": {
        //"handleSize": "undefined%",
        "borderColor":"none",
        "backgroundColor":"rgba(255, 255, 255, 0.05)",
        "fillerColor":"rgba(255, 255, 255, 0.25)",
        "textStyle": {}
    },
    "markPointColors":['#FF5E4E','#1AE38D'],
    "markPoint": {
        "label": {
            "color": "#FFFFFF"
        },
        "emphasis": {
            "label": {
                "color": "#FFFFFF"
            }
        }
    }
}